module.exports = __webpack_public_path__ + "img/grand-restaurant-5.c85fa7d6.jpg";